/* Temporary incident mitigation. Does not change localization, access rules or product data. */
(() => {
  'use strict';
  if (!['mtmshop.eu', 'www.mtmshop.eu'].includes(location.hostname)) return;
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'fi') return;
  if (/^\/(en|sv)(\/|$)/i.test(location.pathname)) return;

  function repair(anchor) {
    if (!anchor || anchor.tagName !== 'A' || !anchor.hasAttribute('href')) return;
    // Explicit language controls must continue to work normally.
    if (anchor.closest('[hreflang], [data-localization], localization-form-component, form[action*="/localization"]')) return;
    const raw = anchor.getAttribute('href');
    let url;
    try { url = new URL(raw, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    if (!/^\/en\/(?:products|collections)(?:\/|$)/.test(url.pathname)) return;
    const path = url.pathname.slice(3) || '/';
    anchor.setAttribute('href', path + url.search + url.hash);
  }

  function scan(node) {
    repair(node);
    node.querySelectorAll?.('a[href]').forEach(repair);
  }

  function start() {
    scan(document);
    // Covers asynchronously loaded cards and variant URL updates without changing content.
    new MutationObserver(records => {
      records.forEach(record => {
        if (record.type === 'attributes') repair(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
  }

  // Capture phase runs before Pitch's product-card click handler reads the anchor.
  for (const type of ['pointerdown', 'click', 'auxclick', 'contextmenu']) {
    document.addEventListener(type, event => {
      const element = event.target instanceof Element ? event.target : event.target?.parentElement;
      repair(element?.closest('a[href]'));
      const card = element?.closest('product-card');
      if (card) scan(card);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
